import React from 'react';
import { PopoverBody } from 'reactstrap';
import { Link } from "react-router-dom";

import {
    formatter, formatterCurrency
} from "../../../../utils/common";

import PopoverFormula from './PopoverFormula';

const SalesSummary = (props) => {

    const {
        data,
        loading,
        getPercentage,
        generateLink,
        dateWiseReturn,
        fillterCurrency
    } = props;

    const currency = fillterCurrency ? fillterCurrency.id : 'GBP';

    return (
        <div className="card">
            {loading && (
                <div className="card-loading">
                    <i className="fa fa-spinner fa-lg spinner" />
                </div>
            )}

            <div className="card-body">
                <div className="d-flex mb-2">
                    <div className="col p-0"><h5 className="card-title">Sales</h5></div>
                    {fillterCurrency && <div className="col-3 p-0 text-right"><h5 className="card-title">{currency}</h5></div>}
                    <div className="col-3 p-0 text-right"><h5 className="card-title">GBP</h5></div>
                </div>
                <div className="d-flex mb-2">
                    <div className="col p-0">
                        <Link to={generateLink('gross-sales')} target="_blank" className="text-decoration-none text-primary">
                            Gross Sales
                        </Link>

                        <PopoverFormula className="ml-3" id="grossSalesFormula">
                            <PopoverBody>
                                <h6>Gross Sales Formula</h6>
                                <p>Gross Sales = UK (Full Price before discount - VAT) Others (Full Price before discount)</p>
                            </PopoverBody>
                        </PopoverFormula>
                    </div>
                    {fillterCurrency && <span className="col-3 p-0 text-right">{formatterCurrency(data.gross_sales_currency, currency)}</span>}
                    <span className="col-3 p-0 text-right">{formatter.format(data.gross_sales)}</span>
                </div>
                <div className="d-flex mb-2">
                    <div className="col p-0">
                        <Link to={generateLink('discounts')} target="_blank" className="text-decoration-none text-primary">
                            Discounts
                            <span className='text-dark pl-2'>({getPercentage(data.gross_sales, data.discount)}%)</span>
                        </Link>

                        <PopoverFormula className="ml-3" id="discountsFormula">
                            <PopoverBody>
                                <h6>Discounts Formula</h6>
                                <p>Discounts = Line Discount, Order Discount, Combination of both</p>
                            </PopoverBody>
                        </PopoverFormula>
                    </div>
                    {fillterCurrency && <span className="col-3 p-0 text-right">({formatterCurrency(data.discount_currency, currency)})</span>}
                    <span className="col-3 p-0 text-right">({formatter.format(data.discount)})</span>
                </div>
                <div className="d-flex mb-2">
                    <div className="col p-0">
                        <Link to={generateLink('returns')} target="_blank" className="text-decoration-none text-primary">
                            Returns
                            <span className='text-dark pl-2'>({getPercentage(data.gross_sales, data.total_return)}%)</span>
                        </Link>

                        <PopoverFormula className="ml-3" id="returnFormula">
                            <PopoverBody>
                                <h6>Returns Formula</h6>
                                <p>Returns {dateWiseReturn ? '' : '(Order Basis)'} = Items which are refunded, void and cancelled</p>
                            </PopoverBody>
                        </PopoverFormula>
                    </div>
                    {fillterCurrency && <span className="col-3 p-0 text-right">({formatterCurrency(data.total_return_currency, currency)})</span>}
                    <span className="col-3 p-0 text-right">({formatter.format(data.total_return)})</span>
                </div>
                <hr />
                <div className="d-flex mb-2">
                    <div className="col p-0">
                        <Link to={generateLink('net-sales')} target="_blank" className="text-decoration-none text-primary">
                            Net Sales
                        </Link>
                        <PopoverFormula className="ml-3" id="netSalesFormla">
                            <PopoverBody>
                                <h6>Net Sales Formula</h6>
                                <p>Net Sales = Gross Sales - Discounts - Returns</p>
                            </PopoverBody>
                        </PopoverFormula>
                    </div>
                    {fillterCurrency && <span className="col-3 p-0 text-right">{formatterCurrency(data.net_sales_currency, currency)}</span>}
                    <span className="col-3 p-0 text-right">{formatter.format(data.net_sales)}</span>
                </div>
                <div className="d-flex mb-2">
                    <div className="col p-0">
                        <Link to={generateLink('shipping-income')} target="_blank" className="text-decoration-none text-primary">
                            Shipping Income
                        </Link>
                        
                        <PopoverFormula className="ml-3" id="shippingFormla">
                            <PopoverBody>
                                <h6>Shipping Income Formula</h6>
                                <p>Shipping Income = Shipping Charge on the order</p>
                            </PopoverBody>
                        </PopoverFormula>
                    </div>
                    {fillterCurrency && <span className="col-3 p-0 text-right">{formatterCurrency(data.shipping_charges_currency, currency)}</span>}
                    <span className="col-3 p-0 text-right">{formatter.format(data.shipping_charges)}</span>
                </div>
                <div className="d-flex mb-2">
                    <div className="col p-0">
                        <Link to={generateLink('taxes')} target="_blank" className="text-decoration-none text-primary">
                            Taxes
                        </Link>
                        
                        <span className='text-dark pl-2'>({getPercentage(data.net_sales, data.total_tax)}%)</span>
                        <PopoverFormula className="ml-3" id="taxesFormula">
                            <PopoverBody>
                                <h6>Taxes</h6>
                                <p>
                                    UK - 20% <br />
                                    Ireland - 23% <br />
                                    Others - No VAT
                                </p>
                            </PopoverBody>
                        </PopoverFormula>
                    </div>
                    {fillterCurrency && <span className="col-3 p-0 text-right">{formatterCurrency(data.total_tax_currency, currency)}</span>}
                    <span className="col-3 p-0 text-right">{formatter.format(data.total_tax)}</span>
                </div>
                <hr />
                <div className="d-flex font-weight-bold">
                    <div className="col p-0">
                        Total Sales

                        <PopoverFormula className="ml-3" id="totalSalesFormla">
                            <PopoverBody>
                                <h6>Total Sales Formula</h6>
                                <p>Total Sales = Net Sales + Shipping + Taxes</p>
                            </PopoverBody>
                        </PopoverFormula>
                    </div>
                    {fillterCurrency && <span className="col-3 p-0 text-right">{formatterCurrency(data.total_sales_currency, currency)}</span>}
                    <span className="col-3 p-0 text-right">{formatter.format(data.total_sales)}</span>
                </div>
            </div>
        </div>
    );
};

export default SalesSummary;